module.exports = __webpack_public_path__ + "img/ic_informaiton.74673436.svg";